import React from 'react';

import { parseVacationRentalDescription, partitionDescriptionTiles } from '@utils';

import { QuintessInfoTiles } from '../quintess-info-tiles';

import './style.scss';

interface IProps {
  hotelDescription: string[];
}

export const QuintessLocationTiles: React.FunctionComponent<IProps> = ({
  hotelDescription,
}: IProps) => {
  const { locationTiles } = React.useMemo(
    () => partitionDescriptionTiles(parseVacationRentalDescription(hotelDescription).tiles),
    [hotelDescription],
  );

  if (!locationTiles.length) {
    return null;
  }

  return (
    <div className="quintess-location-tiles">
      {/* Untitled: the Location section this sits inside already has a heading. */}
      <QuintessInfoTiles tiles={locationTiles} titleId={null} />
    </div>
  );
};
